import { routeName } from '@/constants/routeName';
import { userActionType } from '@/vuex-store/user/actions';
import { authGetterType } from '@/vuex-store/auth/getters';
import { userGetterType } from '@/vuex-store/user/getters';
export default async function user({ to, next, store }) {
    // 유저 정보 유무 판단 - 없으면 로그인 페이지로 이동
    const isAuthenticated = store.getters[authGetterType.isAuthenticated];
    const isInitialized = store.getters[userGetterType.isInitialized];
    if (isAuthenticated && !isInitialized) {
        try {
            await store.dispatch(userActionType.initUser);
        }
        catch {
            await store.dispatch(userActionType.clearUser);
            return next({
                name: routeName.LOGIN,
                query: {
                    redirect: to.fullPath,
                },
            });
        }
    }
    return next();
}
